const Facebook = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 31 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.0833 29.8389C6.23611 28.6306 1 22.6694 1 15.5C1 7.525 7.525 1 15.5 1C23.475 1 30 7.525 30 15.5C30 22.6694 24.7639 28.6306 17.9167 29.8389L17.1111 29.1944H13.8889L13.0833 29.8389Z'
        fill='#0D89F0'
      />
      <path
        d='M21.1391 19.5277L21.7835 15.5H17.9168V12.6805C17.9168 11.5527 18.3196 10.6666 20.0918 10.6666H21.9446V6.96108C20.8974 6.79997 19.7696 6.63885 18.7224 6.63885C15.4196 6.63885 13.0835 8.65274 13.0835 12.2777V15.5H9.4585V19.5277H13.0835V29.7583C13.8891 29.9194 14.6946 30 15.5002 30C16.3057 30 17.1113 29.9194 17.9168 29.7583V19.5277H21.1391Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1609_510'
          x1='15.5'
          y1='28.9963'
          x2='15.5'
          y2='1'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0062E0' />
          <stop offset='1' stopColor='#19AFFF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Facebook;
